<template>
  <div class="TableTemplate" :class="{content: !rawTable, viewportHeight, removeCardStyle}" :id="id">

    <div :class="{'container-fluid': !rawTable}">
      <input v-if="!hideFileInput" ref="input" type="file" id="placeholder-input" style="display: none" @change="change" multiple>

      <NewItemAlert v-if="newlyCreatedAlertKey"
        :alert-key="newlyCreatedAlertKey"

        class="mb-3"
      >
        <template #default="props">
          <slot name="new-item-alert-content" v-bind='props'></slot>
        </template>
      </NewItemAlert>

      <div class="content-wrapper flex-column">

        <div class="pb-2">
          <slot name="above"></slot>
        </div>
        <div class="content-wrapper card-wrapper" :class="{whiteBg}">
          <card class="raw-table-body"
            :class="{removeCard}"
            :body-classes="[
              'table-full-width table-responsive card-body',
              {
                'raw-table-body': rawTable,
              },
              cardClass, removeCard,
            ]"
          >
            <div class="table-content">
              <div v-if="!removeHeader" class='header-wrapper'>
                <slot></slot>
              </div>
              <ImageGallery
                v-model="mainIndex"
                :images="galleryImages"
              >
                <l-table v-if="useOldTable" class="table"
                  :data="value"
                  :class="tableClass"

                  :removeCursor='removeCursor'
                  :columns="columns"
                  :columnVariables="columnVariables"
                  :capitalize="capitalize"
                  :skeletonClass="skeletonClass"
                  :remove-skeleton-array="removeSkeletonArray"

                  :enable-sorting="enableSorting"
                  :disable-loading-content="disableLoadingContent"
                  :columnConfigurationId="columnConfigurationId"
                  :fieldsWithCommas="fieldsWithCommas"
                  :selected="selected"
                  :dragDisabledOnColumns="dragDisabledOnColumns"
                  :heightLimit="heightLimit"

                  :sort="sort"
                  :order="order"

                  @update-column-order="v => $emit('update-column-order', v)"
                  @set-sort="setSort"
                  @set-order="setOrder"
                  @row-click="item => $emit('row-click', item)"
                >
                  <template v-for="(url, index) in imageUrls"
                    v-slot:[`${url}`]="{value, rowIndex, isLoading, styles}"
                  >
                    <TableCell :skeleton-class="skeletonClass" :style="styles" :key="index">
                      <span :class="(loadedImageUrls || value !== '---') ? '' : 'ske'">
                        <!-- <FullPageImageOption v-if="value !== '---'" class="image-expander"> -->
                          <span v-if="isLoading">
                            {{ value }}
                          </span>
                          <img v-else-if="value !== '---'"
                            class="image-expander"
                            :src="value"

                            width="auto"
                            height="50"

                            @click="openGalery(url, value)"
                          />
                        <!-- </FullPageImageOption> -->
                        <div v-else class="d-flex align-items-center" style="width: 50px;height: 50px">
                          ---
                        </div>

                      </span>
                    </TableCell>
                  </template>

                  <template #table-header>
                    <div
                      v-if="isSelectingColumns && !removeCheckboxes"

                      class="d-flex align-items-center multi-select-handle"
                      id="multi-select-handle"

                      @click="selectAllCheckboxes"
                      @mouseenter="$emit('prepare-full-select')"
                    >
                      <FormCheckbox :value='hasAllItemsSelected'
                        :disable-toggle="true"

                        class="multiple-select-checkbox"
                        :class="{active: hasAllItemsSelected}"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #column-select="{selected, item}">
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center"
                      style="background-color: #FBFBFB !important"
                    >
                      <FormCheckbox :value='selected'
                        class="multiple-select-checkbox"
                        :class="{active: selected}"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #before-row="{item}">
                    <slot name="before-row" :item="item"></slot>
                  </template>

                  <template v-for="(_, name) in $scopedSlots"
                    slot-scope="slotData"
                    :slot="name"

                    v-if="name"
                  >
                    <slot
                      :name="name"

                      v-bind="slotData"
                    />
                  </template>

                  <template v-for="slot in extendedSlots"
                    slot-scope="slotData"
                    :slot="slot.slot"
                  >
                    <slot
                      :name="slot.name"
                      :extendedSlot="true"

                      v-bind="{...slotData, ...slot.props}"
                    />
                  </template>
                </l-table>
                <ComposableTable
                  v-else
                  :class="{'disable-text-selection': selected && selected.length}"
                  :noMinHeight="noMinHeight"
                  :data="value"
                  :columns="columns"
                  :variables="columnVariables"
                  :tooltip="columnTooltip"
                  :whiteBg="whiteBg"
                  :input-active="columnInputActive"
                  :removeCursor='removeCursor'

                  :id="id"
                  :enable-sort-by-specific-column="enableSorting"
                  :sort="sort"
                  :dateFormat="dateFormat"
                  :order="order"
                  :onRowClick="onRowClick"
                  :selected="selected"
                  :columnConfigurationId="columnConfigurationId"
                  :removeTableHeader="removeTableHeader"

                  :enableColumnResize="true"
                  :dragDisabledOnColumns="dragDisabledOnColumns"

                  @set-sort="setSort"
                  @set-order="setOrder"
                  @set-filter="setFilter"
                  @update-column-order="v => $emit('update-column-order', v)"
                >
                  <template v-for="(url, index) in imageUrls"
                      v-slot:[`cell-${url}`]="{value, item, rowIndex, isLoading, styles}"
                    >
                      <TableCell :skeleton-class="skeletonClass" :style="styles" :key="index">
                        <span :class="(loadedImageUrls || value !== '---') ? '' : 'ske'">
                          <!-- <FullPageImageOption v-if="value !== '---'" class="image-expander"> -->
                            <span v-if="isLoading">
                              {{ value }}
                            </span>
                            <img v-else-if="value !== '---'"
                              class="image-expander"
                              :src="value"

                              width="auto"
                              height="50"

                              @click="openGalery(url, value)"
                            />
                          <!-- </FullPageImageOption> -->
                          <div v-else class="d-flex align-items-center TAILWIND" style="width: 50px;height: 50px">
                            <div v-if="uploadFileFromTable"
                              class="p-2 rounded border border-gray-200 hover:border-gray-300 hover:bg-gray-100 transition text-gray-600 cursor-pointer"
                              @click="fileExplorer(item)"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                                <path d="M11.47 1.72a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72V7.5h-1.5V4.06L9.53 5.78a.75.75 0 01-1.06-1.06l3-3zM11.25 7.5V15a.75.75 0 001.5 0V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z" />
                              </svg>
                            </div>
                            <span v-else>---</span>
                          </div>

                        </span>
                      </TableCell>
                    </template>

                  <template v-for="(_, name) in $scopedSlots"
                    slot-scope="slotData"
                    :slot="name"

                    v-if="name"
                  >
                    <slot
                      :name="name"

                      v-bind="slotData"
                    />
                  </template>

                  <template #table-header="{isLoading}">
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center multi-select-handle"
                      id="multi-select-handle"

                      @click="selectAllCheckboxes"
                      @mouseenter="$emit('prepare-full-select')"
                    >
                      <FormCheckbox :value='hasAllItemsSelected'
                        :disable-toggle="true"
                        :is-loading="isLoading"

                        class="multiple-select-checkbox"
                        :class="{active: hasAllItemsSelected}"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #column-select="{selected, isLoading, item}">
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center"
                      style="background-color: #FBFBFB !important"

                      @click="selectRangesRow($event, item)"
                    >
                      <FormCheckbox :value='selected'
                        class="multiple-select-checkbox"
                        :class="{active: selected}"

                        :is-loading="isLoading"
                        :disable-toggle="true"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #before-row="{item}">
                    <slot name="before-row" :item="item"></slot>
                  </template>

                  <template v-for="slot in extendedSlots"
                    slot-scope="slotData"
                    :slot="`cell-${slot.slot}`"
                  >
                    <slot
                      :name="`cell-${slot.name}`"
                      :extendedSlot="true"

                      v-bind="{...slotData, ...slot.props}"
                    />
                  </template>
                </ComposableTable>
              </ImageGallery>
            </div>

            <slot name="before-pagination"></slot>
            <div v-if="!hidePagination && max > 1 &&  max >= page" class="PaginationWrapper d-flex justify-content-center pagination-wrapper bottom-sticky">
              <Pagination
                :max="max"

                :value="page"
                @input="setPage"
              />
            </div>
          </card>
          <div>
            <slot name="right-column"></slot>
          </div>
        </div>
        <div>
          <slot name="below"></slot>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table/Table.vue'
import Card from 'src/components/Cards/Card.vue'
import Pagination from 'src/layout/Pagination.vue'
import TableCell from "src/components/Table/TableCell.vue"

import ImageGallery from '../Modals/ImageGallery.vue'
import TableSearchField from 'src/components/Inputs/TableSearchField.vue'
import FormSelect from "src/components/Inputs/FormSelect.vue"
import FormCheckbox from "/src/components/Inputs/FormCheckbox.vue"
/* import FullPageImageOption from '../ImageExpanderModal.vue' */
import NewItemAlert from '../NewItemAlert.vue'
import ComposableTable from '../../components/Product/ComposableTable/ComposableTable.vue'

export default {
  components: {
    FormCheckbox,
    NewItemAlert,
    TableSearchField,
    FormSelect,
    Pagination,
    ComposableTable,
    TableCell,
    ImageGallery,
    // FullPageImageOption,
    Card,
    LTable,
    StatsCard
  },
  props: {
    noMinHeight: Boolean,
    uploadFileFromTable: Boolean,
    dateFormat: String,
    noTimeDateFormat: Boolean,
    whiteBg: Boolean,
    newlyCreatedAlertKey: String,
    viewportHeight: Boolean,
    removeCardStyle: Boolean,
    removeTableHeader: Boolean,
    disableLoadingContent: Boolean,
    dragDisabledOnColumns: Array,
    removeSkeletonArray: Boolean,
    useOldTable: Boolean,
    onRowClick: Function,
    heightLimit: String,
    id: String,
    extendedSlots: Array,

    enableSorting: {
      type: Boolean,
      required: false,
    },
    fieldsWithCommas: {
      type: Array,
      required: false,
    },
    selected: {
      type: Array,
      required: false,
    },
    removeCursor: {
      type: Boolean,
      required: false,
    },
    scrollingLimit: {
      type: Number,
      required: false,
    },
    removeHeader: {
      type: Boolean,
      required: false,
    },
    firstColumnPadding: {
      type: Boolean,
      required: false,
    },
    removeCard: {
      type: Boolean,
      required: false,
    },
    cardClass: {
      type: String,
      required: false,
    },
    tableClass: {
      type: String,
      required: false,
    },
    hidePagination: {
      type: Boolean,
      required: false,
    },
    rawTable: {
      type: Boolean,
      required: false,
    },
    removeCheckboxes: Boolean,
    skeletonClass: {
      type: [String, Object],
      required: true,
    },
    value: {
      type: [Array, String],
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    columnVariables: {
      type: Array,
      required: true,
    },
    columnTooltip: {
      type: Object,
      required: false
    },
    columnInputActive: {
      type: Object,
      required: false
    },
    capitalize: {
      type: Array,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
    page: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      hideFileInput: false,
      uploadingImageForItem: null,

      mainIndex: null,
      galleryImages: [],
      lastCheckedIndex: -1
    }
  },
  methods: {
    fileExplorer(item) {
      this.uploadingImageForItem = item
      this.$refs.input.click()
    },
    change(evt) {
      const files = this.$refs.input.files ? Array.from(this.$refs.input.files) : null

      evt.preventDefault()
      if (!files || !files[0] || files.some(file => !file.type.includes("image"))) {
        return this.$error("Bestandsformaat niet beschikbaar")
      }

      this.uploadFiles(files)
    },
    async uploadFiles(files) {
      const item = this.uploadingImageForItem
      if (!item) return this.resetFile()
      const id = item.id || item.uid || item.sku

      try {
        const currentFiles = []
        const setFirstAsMain = currentFiles.length === 0

        files = files.map((item, index) => ({
          id: item.name + currentFiles.length + index,
          name: item.name,
          is_main: (setFirstAsMain && index === 0) || false,
          caption: "",
          file: item,
        }))

        await this.$handlePromise(
          Promise.all(
            files.map(async item => {
              const payload = new FormData();
              payload.append("filename", item.file);
              payload.append("type", "base");

              await this.axios.post(
                `/api/products/${id}/files`,
                payload,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
              this.$store.dispatch('clearCacheSearch', "products")
            })
          )
        );

        this.$success("Nieuwe afbeelding toegevoegd");
        try {
          this.$parent.refresh()
        } catch (err) {
          console.error(err)
        }
        this.resetFile()
      } catch (err) {
        console.error(err)
      }
    },
    resetFile() {
      this.hideFileInput = true
      this.$nextTick(() => this.hideFileInput = false)
    },

    selectRow(item, action) {
      const id = item.sku || item.id
      const position = this.selected.indexOf(id)
      if (action === 'select' && position === -1) this.selected.push(id)
      else if (action === 'deselect' && position !== -1) this.selected.splice(position, 1)
    },
    selectRangesRow(event, item) {
      const id = item.sku || item.id
      const index = this.value.findIndex(val => val.sku === id)
      const action = this.selected.indexOf(id) === -1 ? 'select' : 'deselect'
      if (event.shiftKey && this.lastCheckedIndex !== -1) {
        let start = this.lastCheckedIndex
        let end = index - 1

        if (start > end) {
          start = index + 1
          end = this.lastCheckedIndex
        }

        for (let x = start; x <= end; x++) {
          const currentItem = this.value[x]
          this.selectRow(currentItem, action)
        }
      }

      this.selectRow(item, action)
      this.lastCheckedIndex = index

      if (this.selected.length === 0) this.lastCheckedIndex = -1
    },
    // @click="openGalery(url, rowIndex)"
    openGalery(key, target_url) {
      this.galleryImages = this.value.map(item => item[key])
      this.galleryImages = this.galleryImages.filter(item => item)
      this.mainIndex = this.galleryImages.findIndex(url => url === target_url)
    },

    selectAllCheckboxes() {
      const selected = this.selected
      const allSelected = this.hasAllItemsSelected
      while (selected.length) {
        selected.pop()
      }
      this.$emit('full-select')

      if (!allSelected) {
        this.value.forEach(item => selected.push(item.uid || item.id || item.sku))
        // this.$parent.backgroundProducts.forEach((item => selected.push(item.id || item.uid || item.sku)))
      }
    },

    setPage(page) {
      this.$emit("set-page", page)
    },
    setFilter(event) {
      this.$emit("set-filter", event)
    },

    getVmValue(fieldName) {
      return this.$parent[fieldName]
    },
    assignVmValue(fieldName, value) {
      this.$parent[fieldName] = value
    },

    setSort(sort) {
      if (!(this.$parent.disabledColumnsSort || []).some(column => column.includes(sort))) {
        this.$parent.sort = sort
      }
    },
    setOrder(order) {
      this.$parent[this.$parent.orderSource] = order
    },
  },
  computed: {
    hasAllItemsSelected() {
      const selected = this.selected
      return this.value && this.value.every && this.value.length && selected && selected.every && this.value.every(item => selected.includes(item.uid || item.sku))
    },

    isSelectingColumns() {
      return this.$parent.selecting
    },
    columnConfigurationId() {
      return this.$parent.columnConfigurationId
    },
    hasColumnConfigurationOptions() {
      return this.$parent.hasTemplateConfiguration
    },
    tableColumnVariables() {
      return this.$parent.tableColumnVariables
    },
    imageUrls() {
      return this.$parent.imageUrls
    },
    loadedImageUrls() {
      return this.$parent.loadedImageUrls
    },
    sort() {
      return this.$parent.sort
    },
    order() {
      return this.$parent[this.$parent.orderSource]
    },
    customOrder() {
      return this.$parent.customOrder
    },
  },
}

</script>

<style>
.disable-text-selection {
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

@media (max-width: 575px) {
  .table-responsive {
    padding-left: 0 !important;
  }
}

.TableTemplate .card-body {
  display: flex;
  flex-direction: column;
  padding: 0px !important;
  margin: 0px !important;
  box-sizing: border-box;
  background-color: #FBFBFB;
}

.whiteBg .card-body {
  background-color: white;
}

.table-content {
  flex-grow: 1;
}

.TableTemplate .form-group {
  margin-bottom: 0px;
}

.removeCard {
  border: none !important;
}

.bottom-sticky {
  background-color: white;
  border: 1px solid #dee2e6;
  z-index: 10;
  height: 50px !important;
  margin: auto !important;
  padding: 10px;
  width: 100%;
  position: sticky;
  inset-block-end: 0;
}

.page-link {
  padding: 0.2rem 0.5rem !important;
}
</style>

<style scoped>

.multi-select-handle {
  background-color: white;
  border-bottom: 1px solid #efeff0;
}

.image-expander {
  height: 50px;
  filter: brightness(1);
  transition-duration: .2s;
  cursor: pointer;
}

.image-expander:hover {
  filter: brightness(.6);
}

img {
  height: 100%;
  width: auto;
}

.image-cell {
  padding: 0px;
}

.TableTemplate, .TableTemplate > div, .content-wrapper, .raw-table-body, .card-body {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  flex-grow: 1;
}

.TableTemplate.viewportHeight, .viewportHeight.TableTemplate > div, .viewportHeight .content-wrapper,  .viewportHeight .raw-table-body, .viewportHeight .card-body {
  height: 100vh !important;
  min-height: unset;
}

.viewportHeight .raw-table-body, .viewportHeight .card-body {
  height: auto !important;
}

.TableTemplate {
  overflow: visible !important;
  width: 100%;
}

.viewportHeight.TableTemplate {
  overflow: auto !important;
}

.content-wrapper {
  display: flex;
  flex-grow: 1;
}

.raw-table-body {
  padding: 0px !important;
  margin: 0px !important;
  flex-basis: 100%;
  flex-grow: 1;
}

.header-wrapper {
  padding: 0px;
}

.table {
  flex-grow: 1;
}

.TableTemplate {
  overflow: auto;
  display: flex;
}

.pagination-wrapper {
  margin-top: 24px;
  margin-bottom: 24px;
}
.custom-select {
  border: none;
  outline: 0;
}

.TableTemplate.removeCardStyle .card {
  border: none !important;
}

.TableTemplate.removeCardStyle th {
  border-left: none;
}

/*@media (max-width: 600px) {
  .card-wrapper {
    flex-direction: column-reverse;
  }
}*/
</style>
